import { NFT as ThirdWebNFT } from "thirdweb";
import { NFT } from "./NFT";

export class NFTPackage extends NFT {
    public readonly rewards: Array<{ type: TraitType, value: number }>;
    public readonly supply: number;
    public readonly packageType: PackageType;

    private quantityOwnedValue: bigint;
    private diceRollsRewardValue: number;

    public get haveDiceRollsReward(): boolean {
        return this.diceRollsRewardValue > 0;
    }

    public get diceRollsReward(): number {
        return this.diceRollsRewardValue;
    }

    public get quantityOwned(): bigint {
        return this.quantityOwnedValue;
    }

    public constructor(nft: ThirdWebNFT & { quantityOwned?: bigint }) {
        super(nft);
        this.quantityOwnedValue = nft.quantityOwned;

        const attributes = <Array<any>>(nft.metadata.attributes as any);

        this.rewards = attributes?.map((attribute) => {
            const type = this.convertAttributeType(attribute?.trait_type);
            const value = parseInt(attribute?.value);

            if (type != null && value != null) {
                if (type === TraitType.DICE_ROLLS) {
                    this.diceRollsRewardValue = value;
                }
                return {
                    type: type,
                    value
                };
            }
            return null;
        }).filter(value => value != null);

        this.packageType = attributes.find((attribute) => attribute?.trait_type === "type" && attribute?.value in PackageType)?.value;

        this.supply = nft.metadata.supply as number;
    }

    public decreaseQuantity(value: bigint = BigInt(1)): void {
        this.quantityOwnedValue -= value;
    }

    private convertAttributeType(traitType: string): TraitType {
        if (Object.values(TraitType).includes(traitType as TraitType)) {
            return traitType as TraitType;
        }
        if (traitType === "diceRolls") {
            return TraitType.DICE_ROLLS;
        }
        return null;
    }
}

export enum TraitType {
    DICE_ROLLS = "dice rolls",
    COINS = "coins",
    SHIELDS = "shields"
}

export enum PackageType {
    GOLDEN_WHEEL = "GOLDEN_WHEEL",
    DAILY_WHEEL = "DAILY_WHEEL",
    HOURLY_BONUS = "HOURLY_BONUS",
    PERSONAL_OFFER = "PERSONAL_OFFER",
    STORE_OFFER = "STORE_OFFER",
    L1_STORE_PACKAGE = "L1_STORE_PACKAGE"
}